export const INTERCOM_LAUNCHER_CLASS_NAME = 'intercom-launcher'
